import React, { useState } from "react";
import pubgrub from "../images/pub-grub.jpg";

const PubGrubMenu = () => {
    const [open, setOpen] = useState(false);

    const toggleMenu = () => {
        setOpen(!open);
    };

    return (
        <div className="tab pub-grub">
            <div className="tab-title" onClick={toggleMenu}>
                Pub Grub
            </div>
            <div className={`tab-content ${open ? "open" : "closed"}`}>
                <div className="tab-image">
                    <img
                        className="pub-grub-image"
                        src={pubgrub}
                        alt="pub-grub"
                    />
                </div>
                <div className="tab-items">
                    <h2>Pizzas</h2>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <h2>Burgers</h2>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>

                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <h2>Steaks & Ribs</h2>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <h2>Baskets</h2>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <h2>Sides</h2>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                    <div className="menu-item">Lorem Ipsum</div>
                    <div className="menu-description">
                        Id dolore, fugiat commodo, aliquip laborum non nulla,
                        minim cupidatat nulla qui ex.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PubGrubMenu;
